// extracted by mini-css-extract-plugin
export default {"banner":"banner-boEkt","image":"image-nq8th"};